module.exports = __webpack_public_path__ + "6049b8d22e08e85d6e751054670573b9.svg";